import { render, staticRenderFns } from "./CorePatientsDrawer.vue?vue&type=template&id=628dacbc"
import script from "./CorePatientsDrawer.vue?vue&type=script&lang=js"
export * from "./CorePatientsDrawer.vue?vue&type=script&lang=js"
import style0 from "./CorePatientsDrawer.vue?vue&type=style&index=0&id=628dacbc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports